var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0002C16 14.3682 15.7013 14.6668 15.3333 14.6668H0.666667C0.298667 14.6668 0 14.3682 0 14.0002C0 13.6322 0.298667 13.3335 0.666667 13.3335H15.3333C15.7013 13.3335 16 13.6322 16 14.0002Z",
    fill: "#5C913B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48611 5.6454H4.59722C4.47456 5.6454 4.375 5.54584 4.375 5.42318V2.31207C4.375 2.1894 4.47456 2.08984 4.59722 2.08984H5.48611C5.60878 2.08984 5.70833 2.1894 5.70833 2.31207V5.42318C5.70833 5.54584 5.60878 5.6454 5.48611 5.6454Z",
    fill: "#A0041E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64084 13.3334C2.57996 11.2636 2.41596 9.77783 2.22218 9.77783C2.02884 9.77783 1.86484 11.2636 1.80396 13.3334H2.64084Z",
    fill: "#FFCC4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44444 7.43616C4.44444 9.91394 3.44978 10.6668 2.22222 10.6668C0.995111 10.6668 0 9.91394 0 7.43616C0 4.9575 1.77778 1.3335 2.22222 1.3335C2.66667 1.3335 4.44444 4.9575 4.44444 7.43616Z",
    fill: "#77B255"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55566 6.22236L9.33344 0.44458L15.1112 6.22236V13.3335H3.55566V6.22236Z",
    fill: "#FFE8B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 6.22241H9.7777V13.3335H9.33325V6.22241Z",
    fill: "#FFCC4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1112 6.66678C14.9974 6.66678 14.8836 6.62322 14.797 6.53656L9.33342 1.073L3.86986 6.53656C3.69608 6.71033 3.4152 6.71033 3.24142 6.53656C3.06764 6.36278 3.06764 6.08189 3.24142 5.90811L9.01919 0.130333C9.19297 -0.0434444 9.47386 -0.0434444 9.64764 0.130333L15.4254 5.90811C15.5992 6.08189 15.5992 6.36278 15.4254 6.53656C15.3388 6.62322 15.225 6.66678 15.1112 6.66678Z",
    fill: "#66757F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33323 6.6668C9.21945 6.6668 9.10567 6.62325 9.01901 6.53658C8.84523 6.36281 8.84523 6.08192 9.01901 5.90814L11.9079 3.01925C12.0817 2.84547 12.3626 2.84547 12.5363 3.01925C12.7101 3.19303 12.7101 3.47392 12.5363 3.64769L9.64745 6.53658C9.56078 6.62325 9.44701 6.6668 9.33323 6.6668Z",
    fill: "#66757F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77783 10.6667H7.55561V13.3334H5.77783V10.6667Z",
    fill: "#C1694F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77783 6.66675H7.55561V8.44453H5.77783V6.66675ZM11.3334 6.66675H13.1112V8.44453H11.3334V6.66675ZM11.3334 10.6667H13.1112V12.4445H11.3334V10.6667Z",
    fill: "#55ACEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72231 12.4406C4.72231 13.1575 4.34098 13.3753 3.87031 13.3753C3.40009 13.3753 3.01831 13.1575 3.01831 12.4406C3.01831 11.7237 3.69964 10.6748 3.87031 10.6748C4.04098 10.6748 4.72231 11.7232 4.72231 12.4406ZM15.9445 12.4406C15.9445 13.1575 15.5632 13.3753 15.0925 13.3753C14.6223 13.3753 14.2405 13.1575 14.2405 12.4406C14.2405 11.7237 14.9219 10.6748 15.0925 10.6748C15.2632 10.6748 15.9445 11.7232 15.9445 12.4406Z",
    fill: "#77B255"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.b084977f.svg";
export { ForwardRef as ReactComponent };